import { createSlice } from "@reduxjs/toolkit";

export const initialState = {
  loading: "",
  list: [],
  byId: {},
};

const TagsSlice = createSlice({
  name: "Tags",
  initialState,
  reducers: {
    recieveTags(state, action) {
      state.list = action.payload
      state.byId = Object.fromEntries(action.payload.map(tag => [tag.id, tag]));
    },
  },
});

export const {
  recieveTags
} = TagsSlice.actions

export default TagsSlice.reducer;
